import {
  Home,
  RefreshCw,
  Building2,
  Briefcase,
  Landmark,
  ArrowUpRight,
} from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const DEFS = [
  { id: "first-home", icon: Home, span: "md:col-span-5" },
  { id: "refinance", icon: RefreshCw, span: "md:col-span-3" },
  { id: "investment", icon: Building2, span: "md:col-span-4" },
  { id: "private", icon: Briefcase, span: "md:col-span-4" },
  { id: "commercial", icon: Landmark, span: "md:col-span-8" },
];

export const Services = () => {
  const { t } = useI18n();
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 border-t border-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 mb-16 md:mb-20">
          <div className="md:col-span-5">
            <span className="overline text-muted-foreground">
              {t.services.overline}
            </span>
            <h2
              className="mt-5 font-heading font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-foreground"
              data-testid="services-heading"
            >
              {t.services.heading_1}{" "}
              <span className="italic font-light text-primary">
                {t.services.heading_em}
              </span>{" "}
              {t.services.heading_2}
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t.services.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-8 gap-5">
          {DEFS.map((s, idx) => (
            <ServiceCard
              key={s.id}
              id={s.id}
              icon={s.icon}
              span={s.span}
              index={idx}
              title={t.services.items[s.id].title}
              desc={t.services.items[s.id].desc}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const ServiceCard = ({ id, icon: Icon, span, index, title, desc }) => (
  <a
    href="#contact"
    data-testid={`service-card-${id}`}
    className={`group relative overflow-hidden bg-card border border-border rounded-sm p-8 md:p-10 flex flex-col justify-between min-h-[280px] md:min-h-[320px] hover:bg-foreground hover:text-background hover:border-foreground transition-all duration-500 ${span}`}
  >
    <div className="flex items-start justify-between">
      <span className="text-xs font-mono text-muted-foreground group-hover:text-background/60 transition-colors">
        0{index + 1}
      </span>
      <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-secondary group-hover:rotate-45 transition-all duration-500" />
    </div>
    <div>
      <Icon className="w-7 h-7 text-primary group-hover:text-secondary mb-6 transition-colors" />
      <h3 className="font-heading text-2xl md:text-3xl font-medium leading-tight tracking-tight">
        {title}
      </h3>
      <p className="mt-4 text-sm leading-relaxed text-muted-foreground group-hover:text-background/70 transition-colors max-w-md">
        {desc}
      </p>
    </div>
  </a>
);

export default Services;
